import request from "@/utils/request";

export default function agentSetAccessControlDeviceHardwareConfig(data) {
  return request.post(
    `/device/accessControlDeviceHardwareConfig/agent/save`,
    data
  );
}
